import { Component, OnInit, Input } from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {ReflexiveRestModel} from 'src/lib/reflexive-model/reflexive-rest-model';
import {ReflexiveField} from 'src/lib/reflexive-model/reflexive-field';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-html-color-field',
  templateUrl: './gelios-html-color-field.component.html',
})
export class GeliosHtmlColorFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  color: string;
  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }
  ngOnInit() {
    super.ngOnInit();
    this.color = this.reflexiveField.value ? this.reflexiveField.value : '#a0a0a0';
  }
  onColorChanged(newColor: string) {
    this.formGroup.controls[this.fieldName].setValue(newColor);
  }
}
